// src/components/lessons/renderers/CodeBlockRenderer.jsx
import React, { useState } from 'react';

const CodeBlockRenderer = ({ block, isMobile }) => {
  const [isHovered, setIsHovered] = useState(false);
  const codeContent = block.content || block.text || '';
    const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{
          fontWeight: '700',
          color: '#3A86FF',  // Blue color for visibility on black background
          background: 'rgba(58, 134, 255, 0.1)',
          padding: '0.125rem 0.375rem',
          borderRadius: '0.25rem'
        }}>
          {part}
        </strong>
      ) : part;
    });
  };
  return (
    <div
      style={{
        background: '#000000',
        borderRadius: '0.75rem',
        padding: isMobile ? '1.25rem' : '1.5rem',
        marginBottom: '1.5rem',
        overflow: 'auto',
        border: '2px solid #000000',
        position: 'relative',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: isHovered ? '0 8px 24px rgba(0, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.15)'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Blue accent bar */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '4px',
        height: '100%',
        background: '#3A86FF',
        opacity: isHovered ? 1 : 0.7,
        transition: 'opacity 0.3s ease'
      }} />

      {/* Decorative dots (terminal style) */}
      <div style={{
        display: 'flex',
        gap: '0.5rem',
        marginBottom: '1rem',
        paddingLeft: '0.5rem'
      }}>
        <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#EF4444' }} />
        <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#F59E0B' }} />
        <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#10B981' }} />
      </div>

      <pre style={{
        color: '#FFFFFF',
        fontSize: isMobile ? '0.8rem' : '0.875rem',
        lineHeight: '1.7',
        margin: 0,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        fontFamily: 'monospace',
        paddingLeft: '0.5rem',
        opacity: 0.95
      }}>
      {processText(codeContent)}
      </pre>

      {/* Corner accent */}
      {isHovered && (
        <div style={{
          position: 'absolute',
          bottom: '8px',
          right: '8px',
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          background: '#3A86FF',
          animation: 'pulse 1.5s ease-in-out infinite'
        }} />
      )}
    </div>
  );
};

export default CodeBlockRenderer;